<template>
  <div>
    <div class="head">
      <SecondaryTitle align="center" class="w-100">
        <span v-t="'Add new business'" />
      </SecondaryTitle>
    </div>

    <v-form>
      <span v-show="false" v-html="csrfTokenInput"></span>
      <v-row class="spacing3">
        <v-col cols="12" sm="12" class="px-3">
          <v-text-field
            name="title"
            v-model="form.title"
            :error="form.state('title')"
            :error-messages="form.error('title')"
            :label="$t('Business name')"
            v-bind="inputProps"
            :rules="rules.required"
          />
        </v-col>

        <!-- <v-col cols="12" sm="12" class="px-3">
          <v-text-field
            v-model="form.tel"
            :error="form.state('tel')"
            :error-messages="form.error('tel')"
            label="Ettevõtte telefoni nr"
            v-bind="inputProps"
          />
        </v-col> -->

        <v-col cols="12" sm="12" class="px-3">
          <country-selector
            v-bind="inputProps"
            v-model="form.country_code"
            :error="form.state('country_code')"
            :error-messages="form.error('country_code')"
          ></country-selector>
        </v-col>
      </v-row>

      <a id="open-dashboard-href" :href="adminRoute" :title="adminRoute">
        <v-alert class="mt-3" v-if="successMessage" type="success" outlined>
          <span v-html="successMessage" />
          <v-btn class="success-button mt-3" color="success" block large tag="button">
            <span class="white--text" v-t="'Open dashboard'" />
          </v-btn>
        </v-alert>
      </a>

      <div class="btn-area">
        <div class="form-helper">
          <div id="accept-terms" class="form-control-label">
            <v-checkbox
              hide-details="auto"
              v-model="form.accepts_terms"
              :label="$t('I have read and accept the terms')"
              :error="form.state('accepts_terms')"
              :error-messages="form.error('accepts_terms')"
              color="secondary"
              required
            />
            <span>
              <a href="/terms" target="_blank" class="link">
                <span v-t="'Read the terms'" />
              </a>
            </span>
          </div>
        </div>

        <div>
          <v-btn
            large
            color="secondary"
            @click.prevent="onSubmit"
            type="submit"
            :loading="loading"
            :disabled="created"
          >
            <v-icon v-if="created" left>mdi-check</v-icon>
            <span v-t="'Save'" />
          </v-btn>
        </div>
      </div>

      <v-alert class="mt-3" v-if="errorMessage" type="error">
        <span v-html="errorMessage" />
      </v-alert>
    </v-form>
  </div>
</template>

<script>
import CountrySelector from "@/_shared/components/localization/CountrySelector";
import { csrfTokenInput } from "@/landing/common/meta/csrf-token";
import SecondaryTitle from "@/landing/components/MainTitle/SecondaryTitle";
import Form from "@/landing/common/form";
import { parseLaravelErrors } from "@/landing/common/functions";
import validationMixin from "@/landing/mixins/validationMixin";

function getBrowserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export default {
  mixins: [validationMixin],
  components: {
    SecondaryTitle,
    CountrySelector,
  },
  data() {
    return {
      csrfTokenInput,
      errorMessage: null,
      successMessage: null,
      loading: false,
      showPassword: false,
      showPasswordConfirm: false,
      inputProps: {
        filled: true,
        color: "secondary",
      },
      form: new Form({
        tel: "",
        title: "",
        country_code: "EE",
        timezone: getBrowserTimezone(),
        user_id: this.$store.state.user.id,
        accepts_terms: false,
      }),
      checkbox: false,
      response: null,
      created: false,
      adminRoute: null,
    };
  },
  methods: {
    onSubmit() {
      //   if (this.$refs.form.validate()) {
      //     console.log("data submited");
      //   }
      this.submit();
    },
    async submit() {
      this.loading = true;
      this.clearMessages();

      /* eslint-disable no-unused-vars */
      //   this.axios.get("/sanctum/csrf-cookie").then(() => {
      this.form
        .post("/entity", "/api")
        .then((response) => {
          this.loading = false;
          this.handleSuccess(response);
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage = this._.get(
            error,
            ["response", "data", "message"],
            this._.get(error, "message", null),
          );
        });
      //   });
    },
    async handleSuccess(response) {
      this.$emit("change");
      this.created = true;
      await this.$store.dispatch("fetchAll");
      this.successMessage = response.data.message;
      this.adminRoute = this._.get(response, ["data", "item", "admin_route"]);
      const shouldRedirectAutomatically = false;
      /**
       * Redirection makes testing difficult. Maybe it's also bad for UX and user should click on link instead?
       */
      if (shouldRedirectAutomatically && this.adminRoute) {
        this.redirectToAdminRoute();
      }
    },
    redirectToAdminRoute() {
      window.location.href = this.adminRoute;
    },
    clearMessages() {
      this.errorMessage = null;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
